import { Link, Toolbar, Typography } from "@mui/material";
import Paper from "@mui/material/Paper";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import IconButton from "@mui/material/IconButton";
import TwitterIcon from "@mui/icons-material/Twitter";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";
import CurrencyExchangeOutlinedIcon from "@mui/icons-material/CurrencyExchangeOutlined";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import { Link as RouterLink, useLocation } from "react-router-dom";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import styles from "../../styles/common/footer.module.css";
import { AnalyticsOutlined, LinkedIn, YouTube } from "@mui/icons-material";

interface Props {
  lightMode?: boolean;
}
const Footer = (props: Props) => {
  const location = useLocation();

  return (
    <>
      <Toolbar
        className={props.lightMode ? styles.toolBarLight : styles.toolBar}
      >
        <Link
          href={"https://www.linkedin.com/company/wolfram-blockchain-labs/"}
          target="__blank"
        >
          <IconButton
            className={props.lightMode ? styles.iconLight : styles.icon}
          >
            <LinkedIn />
          </IconButton>
        </Link>
        <Link
          href={"https://www.youtube.com/@wolframblockchainlabs"}
          target="__blank"
        >
          <IconButton
            className={props.lightMode ? styles.iconLight : styles.icon}
          >
            <YouTube />
          </IconButton>
        </Link>
        <Typography
          variant="caption"
          sx={{ color: props.lightMode ? "#4d4d4d" : "inherit" }}
        >
          © 2025 Wolfram Blockchain Labs. A Wolfram Company.
        </Typography>
      </Toolbar>

      {!props.lightMode && (
        <Paper className={styles.phonePaper}>
          <BottomNavigation showLabels className={styles.bottomNavigation}>
            <BottomNavigationAction
              label="Funds"
              value="funds"
              component={RouterLink}
              to={"/funds"}
              className={`${styles.phoneIcon} ${
                location.pathname === "/funds" && styles.phoneIconActive
              }`}
              icon={
                <CurrencyExchangeOutlinedIcon
                  className={`${styles.phoneIcon} ${
                    location.pathname === "/funds" && styles.phoneIconActive
                  }`}
                />
              }
            />

            <BottomNavigationAction
              label="Challenges"
              value="challenges"
              component={RouterLink}
              to={"/challenges"}
              className={`${styles.phoneIcon} ${
                location.pathname === "/challenges" && styles.phoneIconActive
              }`}
              icon={
                <EmojiEventsOutlinedIcon
                  className={`${styles.phoneIcon} ${
                    location.pathname === "/challenges" &&
                    styles.phoneIconActive
                  }`}
                />
              }
            />
            <BottomNavigationAction
              label="Proposals"
              value="proposals"
              component={RouterLink}
              to={"/proposals"}
              className={`${styles.phoneIcon} ${
                location.pathname === "/proposals" && styles.phoneIconActive
              }`}
              icon={
                <LightbulbOutlinedIcon
                  className={`${styles.phoneIcon} ${
                    location.pathname === "/proposals" && styles.phoneIconActive
                  }`}
                />
              }
            />
            <BottomNavigationAction
              label="Proposers"
              value="proposer"
              component={RouterLink}
              to={"/proposers"}
              className={`${styles.phoneIcon} ${
                location.pathname === "/proposers" && styles.phoneIconActive
              }`}
              icon={
                <PeopleAltOutlinedIcon
                  className={`${styles.phoneIcon} ${
                    location.pathname === "/proposers" && styles.phoneIconActive
                  }`}
                />
              }
            />
            <BottomNavigationAction
              label="Analytics"
              value="analytics"
              component={RouterLink}
              sx={{ padding: "0px" }}
              to={"/analytics"}
              className={`${styles.phoneIcon} ${
                location.pathname === "/analytics" && styles.phoneIconActive
              }`}
              icon={
                <AnalyticsOutlined
                  className={`${styles.phoneIcon} ${
                    location.pathname === "/analytics" && styles.phoneIconActive
                  }`}
                />
              }
            />
          </BottomNavigation>
        </Paper>
      )}
    </>
  );
};

export default Footer;
